import React, { useContext } from 'react';
import { Route, Routes, Navigate, useParams } from 'react-router-dom';
import { ArrowLeft, CreditCard } from 'tabler-icons-react';
import PaymentPlanListView from './PaymentPlanListView';
import PaymentPlanEditView from './PaymentPlanEditView';
import { PAYMENT_PROVIDER_LIST } from '../../../config/constants';
import { Context as RegistrationAdminContext } from '../../../providers/RegistrationAdminProvider';
import { Context as RegistrationAdminDashboardContext } from '../../../providers/RegistrationAdminDashboardProvider';
import TableViewDisabledContent from '../../common/TableViewDisabledContent';
import LoadableView from '../../common/LoadableView';

const PaymentPlanViews = () => {
  const { pkRegAssociation } = useParams();
  const { state: dashboardState } = useContext(
    RegistrationAdminDashboardContext
  );
  const { state } = useContext(RegistrationAdminContext);

  const regAssociation = state.regAssociations.value.find(
    (a) =>
      a.pkRegAssociation ===
      dashboardState.regAssociation.value?.pkRegAssociation
  );
  const paymentProvider = PAYMENT_PROVIDER_LIST.find(
    (p) =>
      p.value ===
      regAssociation?.regAssociationPaymentProvider?.fkPaymentProvider
  );

  return !paymentProvider || !paymentProvider.canCustomizeInstallments ? (
    <LoadableView isLoading={!regAssociation} maxWidth={1200}>
      <TableViewDisabledContent
        disabledContent={{
          title: 'Custom payment plans not available',
          description: `Custom payment plans with ${paymentProvider?.label} are not supported at the moment. Please switch providers to enable this feature.`,
          icon: <CreditCard color="#000" size={150} />,
          primaryButton: {
            label: 'Back to settings',
            icon: <ArrowLeft size={18} />,
            link: '/admin/settings'
          }
        }}
        maxWidth={700}
      />
    </LoadableView>
  ) : (
    <Routes>
      <Route element={<PaymentPlanListView />} path="/" />
      <Route element={<PaymentPlanEditView />} path="/create" />
      <Route
        element={<PaymentPlanEditView duplicate />}
        path=":pkRegAssociationPaymentPlan/duplicate"
      />
      <Route
        element={<PaymentPlanEditView />}
        path=":pkRegAssociationPaymentPlan/*"
      />
      <Route
        element={
          <Navigate
            replace
            to={`/admin/settings/${pkRegAssociation}/payment-plans`}
          />
        }
        path="*"
      />
    </Routes>
  );
};

export default PaymentPlanViews;
